import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {popupView_template} from "../components/templates/popupView_template";

declare var ko: any;
declare var page: any;

export class popup_view extends vnModule_knockoutJS {

    protected popupView: popupView_template;
    protected XHRHdl: XMLHttpRequestHandler;

    buildContent(): Array<Element> {
        this.popupView = new popupView_template("popupView", this.viewModel, this);
        return [this.popupView.build()];
    }

    protected getModuleName(): string {
        return "popup_view";
    }

    fillPage() {
        this.getPopupDataForView()
    }

    private getPopupDataForView() {

        this.loadingIn(this.popupView.builtTemplate);

        let url : string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/popup/get/view/' + this.getVnAppZone().app.params.id + '/';
        let request_parameters : Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(url, request_parameters, this);
        this.XHRHdl.onReadyStateFunction = this.onGetPopupDataForView;
        this.XHRHdl.execute();
    }

    private onGetPopupDataForView(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                let popup = responseParsed.data;
                obj.popupView.setPopupData(popup);
            });

            obj.loadingOut(obj.popupView.builtTemplate);
        }
    }

    protected onClickEditPopup(id){
        let brandId = this.getVnAppZone().app.params.idBrand
        page("/brand/" + brandId + "/newsletter/popups/edit/" + id + '/')
    }

    protected onClickCancel(){
        let brandId = this.getVnAppZone().app.params.idBrand
        page.redirect("/brand/" + brandId + "/newsletter/popups/")
    }
}


// WEBPACK FOOTER //
// ./js/modules/popup_view.ts